// Pure, axios-free pick math extracted from ChildSKUPicker.tsx (lines ~171, ~196, ~223-233). These
// cover the high-risk quantities that drive how much warehouse stock is picked: how much remains on
// a shelf after a picking, how many units are still needed for a child SKU, and the final clamp of a
// requested quantity to what is both available and needed. The component is owned by this workflow
// and is rewired to call these helpers — behaviour is identical.

// Units left on a shelf after a picking: original shelf quantity minus what is already picked there.
export const remainingOnShelf = (shelfQuantity: number, quantityToPick: number): number =>
  shelfQuantity - quantityToPick;

// Total units required for a child SKU across the whole bundle run: per-bundle requirement × the
// number of bundles being built.
export const totalRequired = (requiredQuantity: number, bundleQuantity: number): number =>
  requiredQuantity * bundleQuantity;

// Units still needed for a child SKU: total required minus total already picked.
export const stillNeeded = (totalRequiredUnits: number, totalPicked: number): number =>
  totalRequiredUnits - totalPicked;

// Final quantity to actually pick: the smallest of the requested amount, what the shelf has
// available, and what is still needed (mirrors Math.min(quantity, shelfAvailable, stillNeeded)).
export const clampToAvailableAndNeeded = (
  requested: number,
  shelfAvailable: number,
  needed: number,
): number => Math.min(requested, shelfAvailable, needed);
